/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserMetaDataDto } from '../../models/user-meta-data-dto';

export interface ApiAccountUserInfoGet$Params {
  'api-version'?: string;
}

export function apiAccountUserInfoGet(http: HttpClient, rootUrl: string, params?: ApiAccountUserInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserMetaDataDto>> {
  const rb = new RequestBuilder(rootUrl, apiAccountUserInfoGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserMetaDataDto>;
    })
  );
}

apiAccountUserInfoGet.PATH = '/api/account/user-info';
